import './index.scss';
import { MouseEvent } from 'react';
import { useSelector } from 'react-redux';
import { TableCell, TableRow } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Checkbox } from '@sharedComponents/Checkbox';
import { translate } from '@utils';
import { AnswerPaths } from '@constants/paths';
import { AnswerRow, MgState } from '@types';
import { ArrowRightAverageIcon } from '@images/icons';
import { hasPermissionFeature } from '@hooks/hasPermissionFeature';
import { FeaturePermission, PagePermission, PermissionActions } from '../../../../api/enums';

interface Props {
  answer: AnswerRow;
  order: number;
  handleCheckboxClick: (e: MouseEvent<HTMLTableHeaderCellElement>, answer: AnswerRow) => void;
  page: number;
  rowsPerPage: number;
}

const TableRowAnswer = ({ answer, order, handleCheckboxClick }: Props) => {
  const checkedAnswersIds = useSelector<MgState, string[]>(
    ({ answer }) => answer.checkedAnswersIds
  );
  const hasControllers =
    hasPermissionFeature(
      PagePermission.Answers,
      [FeaturePermission.AnswerTable],
      [PermissionActions.Remove]
    ) ||
    hasPermissionFeature(
      PagePermission.Answers,
      [FeaturePermission.AnswerTable],
      [PermissionActions.Update]
    );

  const canLinkToAnswer = hasPermissionFeature(
    PagePermission.Answers,
    [FeaturePermission.AnswerItem],
    [PermissionActions.View]
  );

  return (
    <TableRow
      className={`${answer.status === 'sent' ? 'sent' : ''} table-row`}
      tabIndex={-1}
      selected={!!checkedAnswersIds?.filter((id) => id === answer.id).length}
      hover={true}
    >
      {hasControllers && (
        <TableCell
          padding="checkbox"
          className="table-cell"
          data-testId="row-checkbox"
          onClick={(event) => handleCheckboxClick(event, answer)}
        >
          <Checkbox checked={!!checkedAnswersIds?.filter((id) => id === answer.id).length} />
        </TableCell>
      )}

      <TableCell
        data-testid={`respondent-${order}`}
        className="table-cell"
        component="th"
        scope="row"
      >
        {answer.respondent}
      </TableCell>
      <TableCell data-testid={`group-${order}`} className="table-cell" align="left">
        {answer.group}
      </TableCell>
      <TableCell data-testid={`createdAt-${order}`} className="table-cell" align="left">
        {answer.createdAt}
      </TableCell>
      <TableCell data-testid={`status-${order}`} className="table-cell" align="left">
        {translate(answer.status)}
      </TableCell>
      <TableCell data-testid={`editedBy-${order}`} className="table-cell" align="left">
        {answer.editedBy}
      </TableCell>
      <TableCell data-testid={`type-${order}`} className="table-cell" align="left">
        {answer.type}
      </TableCell>
      <TableCell data-testid={`hr-${order}`} className="table-cell hr-cell" align="left">
        {answer.hr}
      </TableCell>
      <TableCell className="table-cell" component="th" scope="row" padding="checkbox">
        <Link
          to={`../${AnswerPaths.ANSWER}/${answer.id}`}
          style={{ pointerEvents: canLinkToAnswer === true ? 'all' : 'none' }}
          className="arrow-cell"
          data-testid={`arrow-cell-${order}`}
        >
          {canLinkToAnswer && <ArrowRightAverageIcon />}
        </Link>
      </TableCell>
    </TableRow>
  );
};

export { TableRowAnswer };
